import type { AmbleContent } from "..";
import * as cyberInsuranceInfo from "./cyber-insurance-info";

/**
 * US-specific ambles for SimpleBusiness US
 */
export const simplybusinessUsAmbles: Record<string, AmbleContent> = {
  "cyber-insurance-info": cyberInsuranceInfo.amble,
};
